import { render, staticRenderFns } from "./logs_list.vue?vue&type=template&id=56108f23&scoped=true&"
import script from "./logs_list.vue?vue&type=script&lang=js&"
export * from "./logs_list.vue?vue&type=script&lang=js&"
import style0 from "./logs_list.vue?vue&type=style&index=0&id=56108f23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56108f23",
  null
  
)

export default component.exports